import React, { useState } from 'react';
import { motion } from 'framer-motion';

const servicesOptions = [
  'Website Design or Dev', 'SEO', 'Google Ads', 'Social Media', 
  'Email Marketing', 'Custom Software', 'CRM Setup', 'AI Callbot',
  'Complete Digital Strategy', 'Not Sure'
];

const Contact = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  return (
    <section id="contact" className="section-padding relative">
      <div className="orb orb-1 opacity-20"></div>
      
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center relative z-10"
          >
            <span className="text-cyan-400 font-medium tracking-widest text-base uppercase mb-4 block font-display">
              Let's Build Something Better
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-8 leading-tight">
              You Don't Need Another <span className="text-gradient">Disconnected Vendor.</span>
            </h2>
            <div className="text-lg text-gray-400 space-y-6 font-light">
              <p>You need a team that understands how strategy, marketing, websites, software, customer communication, and automation affect one another.</p>
              <p>Tell us where your business is today, what is getting in the way, and where you want to go. We will help you identify the next best move.</p>
              
              <div className="p-6 border-l-2 border-cyan-500 bg-cyan-900/10 mt-8">
                <p className="font-medium text-gray-200">
                  No canned presentation. No unnecessary sales process. Just a direct conversation with the people who will be responsible for the work.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="glass-panel p-8 md:p-12 rounded-[2.5rem] relative z-10"
          >
            <h3 className="text-3xl font-display font-bold text-white mb-8">Start the Conversation</h3>
            
            {isSubmitted ? (
              <div className="bg-cyan-900/20 border border-cyan-500/30 p-8 rounded-3xl text-center py-16">
                <div className="w-20 h-20 bg-cyan-500/20 text-cyan-400 rounded-full flex items-center justify-center mx-auto mb-6 text-4xl border border-cyan-500/50">✓</div>
                <h4 className="text-2xl font-display font-bold text-white mb-4">Transmission Received</h4>
                <p className="text-gray-400 font-light text-base">One of our founders will review your information and reach out directly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <input 
                      required 
                      type="text" 
                      placeholder="Name *"
                      aria-label="Name"
                      className="w-full px-5 py-4 bg-gray-900/50 border border-gray-700 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-400 font-light text-base" 
                    />
                  </div>
                  <div>
                    <input 
                      type="text" 
                      placeholder="Company"
                      aria-label="Company"
                      className="w-full px-5 py-4 bg-gray-900/50 border border-gray-700 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-400 font-light text-base" 
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <input 
                      required 
                      type="email" 
                      placeholder="Email *"
                      aria-label="Email"
                      className="w-full px-5 py-4 bg-gray-900/50 border border-gray-700 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-400 font-light text-base" 
                    />
                  </div>
                  <div>
                    <input 
                      type="tel" 
                      placeholder="Phone"
                      aria-label="Phone"
                      className="w-full px-5 py-4 bg-gray-900/50 border border-gray-700 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-400 font-light text-base" 
                    />
                  </div>
                </div>

                <div className="pt-2">
                  <label className="block text-sm font-medium text-gray-400 mb-4 font-display tracking-wide uppercase">Services of Interest</label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {servicesOptions.map((service) => (
                      <label key={service} className="flex items-center space-x-3 text-base text-gray-300 font-light cursor-pointer group">
                        <div className="relative flex items-center justify-center">
                          <input type="checkbox" className="peer appearance-none w-5 h-5 border border-gray-600 rounded bg-gray-900/50 checked:bg-cyan-500 checked:border-transparent transition-all" />
                          <svg className="absolute w-3 h-3 text-gray-900 opacity-0 peer-checked:opacity-100 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg>
                        </div>
                        <span className="group-hover:text-cyan-400 transition-colors">{service}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="pt-2">
                  <textarea 
                    rows="4" 
                    placeholder="What would you like to improve?"
                    aria-label="What would you like to improve?"
                    className="w-full px-5 py-4 bg-gray-900/50 border border-gray-700 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-400 font-light resize-none text-base"
                  ></textarea>
                </div>

                <button type="submit" className="btn-neon w-full text-lg mt-2">
                  Initialize Transmission
                </button>
              </form>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;